import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Column } from '../pages/Components/Table/Types';
// import * as Icon from '@mui/icons-material/';
import { MaquinaAtualizar, MaquinaCadastrar, MaquinaConsultar } from '../routes/RoutesNames';
// import { IconButton } from '@mui/material';
import ProdutoController from '../controllers/ProdutoController';
import { toast } from 'react-toastify';
import { ButtonMenu } from '../shared/components/ButtonMenu'

interface Row {
  BtnEditar?: JSX.Element;
  BtnExcluir?: JSX.Element;
  prod_marca?: number;
  prod_modelo?: string;
  prod_numSerie?: string;
  prod_tipoMaquina?: string;
  prod_id?: number;
}

const useMaquinaPesquisa = () => {
  const initialValues = {
    ProdID_Promatec: '',
    Id: null,
    Marca: '',
    Modelo: '',
    NumeroSerie: '',
    TipoMaquina: '',
  };

  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const tableColumns: Column[] = [
    { id: 'Id', label: 'Código', minWidth: 0, align: 'center' },
    { id: 'Marca', label: 'Marca', minWidth: 0 },
    { id: 'Modelo', label: 'Modelo', minWidth: 0 },
    { id: 'NumeroSerie', label: 'Número Série', minWidth: 0 },
    { id: 'TipoMaquina', label: 'Tipo', minWidth: 0 },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right' }
  ];

  const [tableRows, setTableRows] = useState<Row[]>([]);

  const handleSubmit = async (values: any) => {
    const DataRows: any = [];
    setLoading(true);
    const Response = await ProdutoController.ListarMaquina(values);
    console.log(Response.Data);
    setLoading(false);
    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        DataRows.push({
          Id: item.prod_id,
          Marca: item.prod_marca ? item.prod_marca : ' - ',
          Modelo: item.prod_modelo ? item.prod_modelo : ' - ',
          NumeroSerie: item.prod_numSerie ? item.prod_numSerie : ' - ',
          TipoMaquina: item.prod_tipoMaquina ? item.prod_tipoMaquina : ' - ',
          BtnMenu: (
            <ButtonMenu
              items={[
                { onClick: () => handleConsultItem(item), menu: "Consultar" },
                { onClick: () => handleEditItem(item), menu: "Editar" },
                { onClick: () => handleDeleteItem(item.prod_id!), menu: "Excluir", confirmar: `Excluir a máquina ${item.prod_marca ?? ''} ${item.prod_modelo ?? ''}? Esta ação não pode ser desfeita.` },
              ]}
            />
          ),
        });

      });
      setTableRows(DataRows);
    } else {
      setTableRows([]);
    }
  };

  const handleNavigation = async (): Promise<void> => {
    navigate(MaquinaCadastrar);
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      navigate(MaquinaAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      navigate(MaquinaAtualizar.replace(':id', item?.prod_id?.toString() ?? ''),{});
    }
  };

  const handleConsultItem = (item: Row) => {
    navigate(
      MaquinaConsultar.replace(':id', item?.prod_id?.toString() ?? '')
    );
  }

  const handleDeleteItem = async (prod_id: number) => {
    const request: any = { ProdutoId: prod_id };
    const response = await ProdutoController.Excluir(request);
    if (response.StatusCode === 204) {
      toast('Máquina excluído com sucesso!', {
        type: 'success',
      });
      await handleSubmit(initialValues);
    } else {
      toast('Erro ao excluir a máquina!', {
        type: 'error',
      });
    }
  };

  useEffect(() => {
    handleSubmit(initialValues);
  }, []);

  return {
    handleNavigation,
    handleSubmit,
    handleEditItem,
    handleConsultItem,
    handleDeleteItem,
    initialValues,
    loading,
    tableColumns,
    tableRows,
  };
};

export default useMaquinaPesquisa;
